module.exports = __webpack_public_path__ + "img/emojiLogout.d329b8db.svg";